import { render, staticRenderFns } from "./BlacklistForm.vue?vue&type=template&id=c8af63a6&scoped=true"
import script from "./BlacklistForm.vue?vue&type=script&lang=js"
export * from "./BlacklistForm.vue?vue&type=script&lang=js"
import style0 from "./BlacklistForm.vue?vue&type=style&index=0&id=c8af63a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8af63a6",
  null
  
)

export default component.exports